import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { secureStorage } from '../../lib/secureStorage'

interface User {
  id: string
  email: string
  first_name: string
  last_name: string
  is_verified?: boolean
}

export interface AuthState {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
}

const storedUser = secureStorage.getUser()

const initialState: AuthState = {
  user: storedUser,
  isAuthenticated: !!storedUser,
  isLoading: false,
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    loginSuccess: (state, action: PayloadAction<{
      user: User
    }>) => {
      state.user = action.payload.user
      state.isAuthenticated = true
      state.isLoading = false
      state.error = null

      secureStorage.setUser(action.payload.user)
    },
    logout: (state) => {
      state.user = null
      state.isAuthenticated = false
      state.isLoading = false
      state.error = null

      secureStorage.clear()
    },
    updateUser: (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload }
        secureStorage.setUser(state.user)
      }
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const {
  setLoading,
  setError,
  loginSuccess,
  updateUser,
  logout,
  clearError,
} = authSlice.actions

export default authSlice.reducer
